// @ts-nocheck
var _learnq = _learnq || []

// devLog — this file calls devLog() ~35 times but its definition never came across with
// the cart port, so every call site threw "ReferenceError: devLog is not defined".
// Most calls sit inside .catch() blocks (invisible), but removeItem() calls it on the happy
// path, so the whole REMOVE button died before it could fire its request.
// Quiet by default; set window.SLIDE_CART_DEBUG = true or add ?slidecart_debug=1 to see logs.
if (typeof window.devLog !== "function") {
  window.devLog = function () {
    if (
      window.SLIDE_CART_DEBUG ||
      /[?&]slidecart_debug=1/.test(window.location.search)
    ) {
      console.log.apply(
        console,
        ["[slide-cart]"].concat(Array.prototype.slice.call(arguments))
      )
    }
  }
}

document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg")
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")"
    e.target.removeAttribute("data-bg")
    e.target.style.filter = "blur(0px)"
  }
})

// Put your application javascript here
const SingleUpsell = {
  template: /*html*/ `  
  <div class="flex flex-col justify-center items-center bg-[#f2f1f58f] p-4 pb-6 rounded-lg col-span-1 "  v-if="item && !isInCart(item)">
  <div class="w-20 h-20"> 
  <img  :src="current_featured_image" width="1500" height="1500" alt="">
  </div>
  <p class="pt-4 text-center text-darkGreen"
  :href="item.url" 
  >{{item.title}}</p> 
<div v-if="item.variants.length>1" class="block">
              <select @change="updateSelectedVariant" class="upsell-select-updated text-darkGreen pr-[40px] border-0 border-b-1 border-darkGreen focus:outline-none focus:border-darkGreen mb-2 !text-[12px] lg:text-[14px] px-2 " 
              :value="current_variant.id"              >
                <option v-for="variant in item.variants" :key="variant.id" :value="variant.id">
                  {{ variant.title }}
                </option>
              </select>
              <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-if="item.tags.includes('bf-sale')">
               <span v-if="item?.handle?.includes('fasting-shake')">{{moneyDown(current_variant.price*70)}}
              </span>
              <span v-else >{{moneyDown(current_variant.price)}}
              </span>
 
              </span> 
              <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-else>
              {{money(current_variant.price*100)}}
              </span> 
</div> 
<span v-else class="text-darkGreen text-[12px] py-2">
<span>{{item.variants[0].title.replace('Default Title','') }}</span>
 <span class="text-darkGreen text-xs font-bold block text-center mb-2 mt-2" v-if="item.tags.includes('bf-sale')">
             
              <span>
              {{moneyDown(current_variant.price*70)}}
              </span>   
    </span>   
         <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-else>
              {{money(current_variant.price*100)}}
              </span>  
</span>
  <div class="w-100">
  
  <button class="flex flex-col justify-center h-10 px-8 bg-white text-darkGreen rounded-3xl !mx-auto"
   @click="UpsellAddToCart(item)" 
  >
  <div class="flex items-center justify-center cursor-pointer">
  <div class="spinner-loader" v-if="item.loading"> </div>
  <span v-else class="text-xs font-bold">Add</span> 

 

  </div>
  </button>
  </div>
  </div>
 
  `,
  props: ["item", "cart"],

  data() {
    return {
      current_variant: false,
    }
  },
  methods: {
    UpsellAddToCart(item) {
      item.loading = true
      store.addToCartWithProperties({
        id: this.current_variant.id,
        quantity: 1,
        properties: { upsell: true },
        cb: (response) => {
          item.loading = false
        },
      })
    },
    moneyDown(value) {
      if (!value) return '$'+0;
      return "$" + Math.floor(value / 100).toFixed(2)
    },
    money(value) {
      if (!value) return "$0.00"
      return "$" + (value / 100).toFixed(2)
    },
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    updateSelectedVariant(event) {
      const variantId = event.target.value
      this.current_variant = this.item.variants.find(
        (variant) => variant.id == variantId
      )
    },
  },
  computed: {
    variants() {
      return item.variants
    },
    current_featured_image() {
      let image = this.item.images[0].src || this.item.images[0]
      if (this.current_variant && this.current_variant.featured_image) {
        image = this.current_variant.featured_image.src
      }

      return image
    },
  },
  mounted() {
    if (this.item && this.item.variants && this.item.variants.length > 0) {
      this.current_variant = this.item.variants[0]
    }
  },
}

// Put your application javascript here
const SingleUpsellNew = {
  template: /*html*/ `  
  <div class="col-span-1 flex flex-col items-center justify-center rounded-md border-[#1E4036] border p-4 " v-if="item && !isInCart(item)">
  <div class="flex w-full gap-1">
    <div class="w-[30%]">
      <img :src="current_featured_image" width="1500" height="1500" alt="" class="w-[118px] h-[121px] rounded-md object-cover" />
    </div>
    <div class="ml-2 flex flex-col gap-2 justify-center w-[70%]">
      <p class="text-left text-[14px] font-semibold text-darkGreen" :href="item.url">{{item.title}}</p>

      <span class="text-darkGreen  block text-left text-xs font-bold"> {{money(current_variant.price*100)}} </span>


 <div class="flex justify-between gap-2  ">
    <div v-if="item.variants.length>1" class=" block border-[#1E4036] border h-7 my-auto px-2 rounded-full max-w-[190px]">
      <select @change="updateSelectedVariant" class="upsell-select-updated my-auto  w-full rounded-md border-0 border-b-1 border-black px-2  border-none !text-[12px] font-semibold text-darkGreen focus:border-darkGreen focus:outline-none lg:text-[14px]" :value="current_variant.id">
        <option v-for="variant in item.variants" :key="variant.id" :value="variant.id">{{ variant.title }}</option>
      </select>
    </div>
    <span v-else class="block border h-7 my-auto px-2 rounded-full border-[#1E4036]  w-full text-[12px] py-1 max-w-[190px]">
      <span>{{item.variants[0].title.replace('Default Title','Default Title') }}</span>
    </span>
    <div class=" ">
      <button class="bg-lightGreen  !mx-auto flex h-7 w-full flex-col justify-center rounded-full px-4 text-center text-white" @click="UpsellAddToCart(item)">
        <div class="mx-auto flex cursor-pointer items-center justify-center text-center">
          <div class="spinner-loader" v-if="item.loading"></div>
          <span v-else class="text-xs font-bold flex items-center gap-1"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 0V10" stroke="white" stroke-width="1.5"/>
<path d="M10 5L-1.78814e-07 5" stroke="white" stroke-width="1.5"/>
</svg>
ADD</span>
        </div>
      </button>
    </div>
  </div>


    </div>

  </div>
  
 
</div>

 
  `,
  props: ["item", "cart"],

  data() {
    return {
      current_variant: false,
    }
  },
  methods: {
    UpsellAddToCart(item) {
      item.loading = true
      store.addToCartWithProperties({
        id: this.current_variant.id,
        quantity: 1,
        properties: { upsell: true },
        cb: (response) => {
          item.loading = false
        },
      })
    },
    moneyDown(value) {
      if (!value) return '$'+0;
      return "$" + Math.floor(value / 100).toFixed(2)
    },
    money(value) {
      if (!value) return '$'+0;
      return "$" + (value / 100).toFixed(2)
    },
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    updateSelectedVariant(event) {
      const variantId = event.target.value
      this.current_variant = this.item.variants.find(
        (variant) => variant.id == variantId
      )
    },
  },
  computed: {
    variants() {
      return item.variants
    },
    current_featured_image() {
      let image = this.item.images[0].src || this.item.images[0]
      if (this.current_variant && this.current_variant.featured_image) {
        image = this.current_variant.featured_image.src
      }

      return image
    },
  },
  mounted() {
    if (this.item && this.item.variants && this.item.variants.length > 0) {
      this.current_variant = this.item.variants[0]
    }
  },
}

// Put your application javascript here
function getParam(param) {
  return new URLSearchParams(window.location.search).get(param)
}

let clear = getParam("clear")
let discount = getParam("discount")
if (clear == "1") {
  Cookies.set("provider_code", null, { expires: 700 })
  localStorage.setItem("provider_code", null)
  Cookies.set("discount_code", null)
}
if (discount && discount != "") {
  localStorage.setItem("provider_code", null)
  Cookies.set("provider_code", null, { expires: 700 })
  Cookies.set("discount_code", discount)
  //  localStorage.setItem("discount_code", discount);
}

const local_discount_code = Cookies.get("discount_code")
const isLocal = localStorage.getItem("doLocal")
const is_welcome_gift = localStorage.getItem("is_welcome_gift")
const allowedGifts = [
  {
    enabled: false,
    handle: "free-fast-bar-coconut-macadamia-12ct-1",
    description: "Auto Add Free Fasting Bar Coconut Macadamia 12ct",
    variant_id: 45858930032798,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      cart_total: {
        operator: ">=",
        value: 50, // 100.00
      },
      // sku_single_item: {
      //   operator: ">",
      //   value: 50,
      // },
      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR004",
      //   "PR039-PNK",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "HOLIDAY-BUNDLE",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // product_type_single_item: {
      //   operator: "!=",
      //   value: "Upsell",
      // },
    },
  },
  {
    enabled: false,
    handle: "free-prolon-l-biome",
    description: "Auto Add Free L Biome above $150",
    variant_id: 44455316848798,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      cart_total: {
        operator: ">=",
        value: 15000, // 150.00
      },
      never_add_when_item: ["prolon-bundle-offer"],
      // sku_single_item: {
      //   operator: ">",
      //   value: 50,
      // },
      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   41640431255710, 41640431124638, 41640431288478, 41640431157406,
      //   41640431321246, 41640431190174,
      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-l-spread",
    description: "Auto Add Free l-spread for orders with prolon",
    variant_id: 42962227495070,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },

      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      variant_in_cart: [
        42897185931422, 42897185833118, 42897185865886, 42897185898654,
        43716177985694, 43716178018462,
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-shake",
    description: "Auto Add Free fasting shake for orders with prolon",
    variant_id: 43022229536926,
    quantity_to_add: 1, 
    match_quantity: false,
    conditions: {
      isSubscriptionProduct: "yes",
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR005",
        "PR039", 

        // "PR001-RKBUNDLE",
        // "PR002-RKBUNDLE",
        // "PR039-RKBUNDLE",
        // "PR039-3Boxbundle",
        // "PR001-2BOX",
        // "PR002-2BOX",
        // "PR0039-2BOX",
        // "PR001-3BOX",
        // "PR002-3BOX",
        // "PR0039-3BOX",
        // "4boxbulk",
        // "PR039-4Boxbundle",
        // "3boxbulk",
        // "longevity-bundle",
        // "if-bundle",
        // "PR001-BUNDLE-3",
        // "PR039Boxbundle-4",
        // "PR039bundle-3"
      ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   // 42897185931422, 42897185833118, 42897185865886, 42897185898654,43716177985694,43716178018462 //affiliates
      //   43658982326430,
      //   43658982293662, 43658982260894, 41640431190174, 41640431321246,
      //   41640431157406, 41640431288478, 41640431124638, 41640431255710,
      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      }, 
    },
  },
  {
    enabled: false,
    handle: "free-l-protein",
    description: "Auto Add Free l-protein for orders with prolon",
    variant_id: 43972864344222,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR039",
        "PR001-RKBUNDLE",
        "PR002-RKBUNDLE",
        "PR039-RKBUNDLE",
        "PR039-3Boxbundle",
        "PR001-2BOX",
        "PR002-2BOX",
        "PR0039-2BOX",
        "PR001-3BOX",
        "PR002-3BOX",
        "PR0039-3BOX",
        "4boxbulk",
        "PR039-4Boxbundle",
        "3boxbulk",
        "longevity-bundle",
        "if-bundle",
        "PR001-BUNDLE-3",
        "PR039Boxbundle-4",
        "PR039bundle-3",
      ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   // 42897185931422, 42897185833118, 42897185865886, 42897185898654,43716177985694,43716178018462 //affiliates
      //   43658982326430,
      //   43658982293662,
      //   43658982260894,
      //   41640431190174,
      //   41640431321246,
      //   41640431157406,
      //   41640431288478,
      //   41640431124638,
      //   41640431255710

      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false, //is_welcome_gift == "1" ? true : false,
    handle: "free-welcome-kit-v2",
    description: "Auto Add Free welcome-kit",
    variant_id: 47948612665502,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      isSubscriptionProduct: "yes",
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR005",
        "PR039",
        // "PR001-RKBUNDLE",
        // "PR002-RKBUNDLE",
        // "PR039-RKBUNDLE",
        // "PR039-3Boxbundle",
        // "PR001-2BOX",
        // "PR002-2BOX",
        // "PR0039-2BOX",
        // "PR001-3BOX",
        // "PR002-3BOX",
        // "PR0039-3BOX",
        // "4boxbulk",
        // "PR039-4Boxbundle",
        // "3boxbulk",
        // "longevity-bundle",
        // "if-bundle",
        // "PR001-BUNDLE-3",
        // "PR039Boxbundle-4",
        // "PR039bundle-3"
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  }, 
    {
    enabled: false, 
    handle: "free-welcome-kit-v2",
    description: "Auto Add Free welcome-kit when prolon-5-day-fmd-26 is in cart",  
    variant_id: 47948612665502,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      handle_in_cart: ["prolon-5-day-fmd-26","prolon-offer-24"],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  { 
    enabled: false,
    handle: "free-fasting-shake",
    description: "Auto Add Free fasting shake when PR005 SKU is in cart",
    variant_id: 43022229536926,
    quantity_to_add: 1, 
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 0,
      },
      skus_in: [
        "PR005",
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false, // DISABLED: prolon-offer-24 buy-3 free gift
    handle: "free-l-protein-1",
    description:
      "Auto Add Free L-Protein (Berry) when the combined quantity of prolon-offer-24 and prolon-professional-program-2 (any flavor/variant) is 3 or more; removed when it drops below 3",
    variant_id: 47929945522334,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      // Sums the quantity of every line in the cart that belongs to ANY of the target
      // products below (matched by handle or product_id, across flavors/variants) and
      // only qualifies when that combined quantity reaches the value below.
      product_quantity_total: {
        handles: ["prolon-offer-24", "prolon-professional-program-2"],
        product_ids: [8602639171742, 8156423520414],
        operator: ">=",
        value: 3,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-bar",
    description:
      "Auto Add Free Fasting Bar when prolon-offer-24 / prolon-professional-program-2 is added as a ONE-TIME variant (not subscription). Removed when no qualifying one-time line remains.",
    // Free gift variant id (product 8777966289054).
    variant_id: 47952751788190,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      // Counts only NON-subscription (one-time) cart lines belonging to the target
      // products (matched by handle or product_id, across flavors/variants).
      // Subscription lines (with a selling_plan_allocation) are ignored.
      product_quantity_total: {
        handles: ["prolon-offer-24", "prolon-professional-program-2"],
        product_ids: [8602639171742, 8156423520414],
        only_one_time: true,
        operator: ">=",
        value: 1,
      },
    },
  },
]

if (window.cart_gift) {
  // allowedGifts.push({
  //   enabled: window.cart_gift.enabled,
  //   isDisplay: true,
  //   type: 'choose_gift',
  //   name: 'free_sample',
  //   displayText: `Free Gift`,
  //   targetValue: window.cart_gift.threshold,
  //   icon: 'https://cdn.shopify.com/s/files/1/2569/3918/files/free-shipping-removebg-preview_bd38e921-508a-4fad-bafd-6ce3f7c9ae92.png?v=1677098182',
  //   // handle: 'free-lashies-baby-on-the-go',
  //   description: 'Choose gift options from the collection below',
  //   // variant_id: 40239365980238,
  //   collection_handle: window.cart_gift.collection_handle,
  //   allowed_variants: [41562770767950, 40729757286478],
  //   quantity_to_add: 1,
  //   conditions: {
  //     isSubscriptionProduct: window.cart_gift.isSubscriptionProduct ? 'yes': 'no',
  //     cart_total: {
  //       operator: '>=',
  //       value: window.cart_gift.threshold * 100, // 100.00
  //     },
  //     cart_items: {
  //       operator: '>=',
  //       value: 1,
  //     },
  //   },
  //   successMessage: window.cart_gift.success_message,
  //   remainingMessage: window.cart_gift.remaining_message,
  // });
} 

const store = Vue.reactive({
  state: {
    cartState: [],
    loadingCart: true,
    updatingCart: false,
    shopify_cart: null,
    freeGiftsCollection: [],
    recommendedCollection: [],
    allowedGifts: allowedGifts.filter((gift) => gift.enabled),
    upsell_in_cart: false,
    _processingGifts: false,
  },

  getCart() {
    // this.state.loadingCart = true;
    return fetch("/cart.js")
      .then(async (response) => {
        let data = await response.json()
        this.state.loadingCart = false
        this.state.cartState.unshift(data)
        this.state.updatingCart = false
        this.state.cartState.length = 1
        await this.checkCart()
        return data
      })
      .catch((error) => {
        devLog(error)
      })
  },
  // Refresh cart data only (no gift processing) — used after gift updates
  _refreshCartData() {
    return fetch("/cart.js")
      .then(async (response) => {
        let data = await response.json()
        this.state.loadingCart = false
        this.state.cartState.unshift(data)
        this.state.updatingCart = false
        this.state.cartState.length = 1
        return data
      })
      .catch((error) => {
        devLog(error)
      })
  },
  async getShopifyCart() {
    return new Promise((resolve) => {
      fetch("/cart?view=slidecart")
        .then(async (response) => {
          try {
            // Check if response is OK
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }

            // Get response as text first
            const text = await response.text()
            
            // Try to parse the text as JSON
            try {
              const data = JSON.parse(text)
              resolve(data)
            } catch (parseError) {
              devLog("Error parsing cart JSON:", parseError)
              devLog("Response text:", text.substring(0, 500))
              resolve(null)
            }
          } catch (error) {
            devLog("Error fetching cart:", error)
            resolve(null)
          }
        })
        .catch((error) => {
          resolve(null)
          devLog(error)
        })
    })
  },
  setCartLoading() {
    this.state.updatingCart = true
    // Watchdog: `updatingCart` disables REMOVE and the +/- buttons, so if a cart request
    // never resolves the whole cart goes dead. Release it after a few seconds.
    if (this._loadingWatchdog) clearTimeout(this._loadingWatchdog)
    this._loadingWatchdog = setTimeout(() => {
      if (store.state.updatingCart) {
        devLog("Cart loading watchdog fired — re-enabling cart controls")
        store.state.updatingCart = false
      }
    }, 6000)
  },
  getRecommendedCollection() {
    fetch("/collections/prolonlife-cart-upsell/products.json")
      .then((response) => response.json())
      .then((data) => {
        if (data && data.products) {
          this.state.recommendedCollection = data.products
        }
      })
      .catch((error) => {
        devLog(error)
      })
  },
  getFreeGiftsCollection() {
    axios
      .get("/collections/free-gifts-cart/products.json")
      .then((response) => {
        if (response.data && response.data.products) {
          this.state.freeGiftsCollection = response.data.products
        }
      })
      .catch((error) => {
        devLog(error)
      })
  },
  addToCart(id, quantity, selling_plan, cb) {
    store.setCartLoading()
    let props = { id, quantity }
    if (selling_plan) {
      props.selling_plan = selling_plan
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(props),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.message && data.status == 422) {
          alert(data.message)
          return
        }

        if (window.doLeadforPodscribe) {
          window.doLeadforPodscribe(id)
        }

        if (window.posthog && window.posthog.capture) {
          window.posthog.capture("direct_add_to_cart", {
            variant_id: id,
            quantity: quantity,
            selling_plan: selling_plan,
          })
        }
        await store.getCart()
        if (cb) cb(data)
        else toggleCart.showCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },

  addToCartWithProperties({ id, quantity, selling_plan, cb, properties }) {
    store.setCartLoading()

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [{ id, quantity, selling_plan, properties }],
      }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (window.doLeadforPodscribe) {
          window.doLeadforPodscribe(id)
        }

        if (window.posthog && window.posthog.capture) {
          let isUpsell = properties && properties.upsell
          window.posthog.capture("direct_add_to_cart", {
            variant_id: id,
            quantity: quantity,
            selling_plan: selling_plan,
            properties: properties,
            isUpsell: isUpsell,
          })
        }
        await store.getCart()
        if (cb) cb(data)
        else toggleCart.showCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },

  async bulkAddToCart(items, cb) {
    store.setCartLoading()
    await fetch("/cart/clear.js", { method: "POST" })
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        await store.getCart()
        if (cb) cb(data)
      })
      .catch((error) => {
        devLog(error)
      })
  },

  async bulkAddToCartClear(items, cb) {
    store.setCartLoading()

    // Clearing the cart
    try {
      const clearResponse = await fetch("/cart/clear.js", { method: "POST" })
      if (!clearResponse.ok) {
        throw new Error("Error clearing cart")
      }

      // Adding items to cart
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })

      if (!addResponse.ok) {
        throw new Error("Error adding items to cart")
      }

      const data = await addResponse.json()
      await store.getCart()
      if (cb) cb(data)
    } catch (error) {
      devLog(error)

      // Error handling logic
      if (error instanceof Error) {
        // Handle Fetch API errors
        alert(error.message)
      } else {
        // Handle other types of errors (e.g., network issues)
        alert("An unexpected error occurred")
      }

      if (cb) cb(error)
    }
  },

  async bulktUpdateCart(items, cb, attributesData) {
    let new_items = {}
    for (let key of Object.keys(items)) {
      if (items[key] >= 0 && key != undefined) new_items[key] = items[key]
    }
    items = new_items

    let isItems = Object.keys(items).length > 0
    if (!isItems && !attributesData) {
      return
    }
    let json_key = Object.keys(items).join("_")
    let errorCount = window[`error_${json_key}`] || 0
    let errorLimit = 3
    if (errorCount >= errorLimit) {
      // Bail out BEFORE flagging the cart as loading — flagging it and returning left
      // state.updatingCart stuck true, which keeps every REMOVE / +- button disabled.
      devLog(`Error limit reached for ${json_key}`)
      return
    }

    store.setCartLoading()
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: items,
        attributes: {
          _free_gift_above_subtotal: JSON.stringify([
            {
              free_gift_variant_id: "45779086442654",
              above_subtotal: 199,
            },
          ]),
        },
      }),
    })
      .then(async (response) => {
        try {
          // Check if response is OK
          if (!response.ok) {
            if (response.status === 429) {
              devLog("Too many requests - rate limited")
              window[`error_${json_key}`] = ++errorCount
              return { status: "too_many_requests" }
            }
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          const contentType = response.headers.get("content-type")
          if (!contentType || !contentType.includes("application/json")) {
            throw new Error("Response is not JSON")
          }

          return await response.json()
        } catch (error) {
          devLog("Error parsing cart update response:", error)
          window[`error_${json_key}`] = ++errorCount
          return { status: "error", error: error.message }
        }
      })
      .then(async (data) => {
        if (data.status == "too_many_requests") {
          window[`error_${json_key}`] = ++errorCount
          // Release the cart so the shopper can still remove / change items
          store.state.updatingCart = false
        } else if (data.status == "error") {
          devLog("Cart update error:", data.error)
          store.state.updatingCart = false
        } else if (!store.state._processingGifts) {
          // Only auto-refresh cart if not inside gift processing
          // (gift processing does its own _refreshCartData at the end)
          store.getCart()
        }
        if (cb) cb(data)
      })
      .catch((error) => {
        window[`error_${json_key}`] = errorCount++
        store.state.updatingCart = false

        devLog(error)
      })
  },

  async checkRecommendedUpsells(cart) {
    if (cart) {
      totalRecommendationProductsinCart = 0
      cart.items.forEach((item) => {
        if (
          item &&
          this.state.recommendedCollection &&
          this.state.recommendedCollection.length > 0
        ) {
          this.state.recommendedCollection.forEach((product) => {
            if (item.product_id == product.id) {
              totalRecommendationProductsinCart++
            }
          })
        }
      })

      if (
        totalRecommendationProductsinCart > 0 &&
        totalRecommendationProductsinCart == cart.items.length
      ) {
        this.clearCart()
      }
    }
  },
  async processAllowedGifts(cart) {
    let _shopifyCart = await this.getShopifyCart()
    this.state.shopify_cart = _shopifyCart
 
    // console.log(_shopifyCart);

    if (cart && cart.items && cart.items.length > 0) {
      let giftsToUpdate = {}
      let cartAttributes = cart.attributes
      let giftCartProducts = []

      this.state.allowedGifts.forEach((gift) => {
        let giftInCart = false
        let giftVariantInCart = false
        let giftQuantityInCart = 0
        let giftConditionsMet = true
        let skus_in = gift.conditions.skus_in
        let InvalidProductType = false
        let ConditionalProductQuantity = 0
        let isSubscriptionProduct = false

        if (gift.conditions.product_type_single_item) {
          if (gift.conditions.product_type_single_item.operator == "!=") {
            InvalidProductType = gift.conditions.product_type_single_item.value
          }
        }

        cart.items.forEach((item) => {
          let itemCounted = false
          if (item.variant_id == gift.variant_id) {
            giftVariantInCart = true
            giftInCart = true
            giftQuantityInCart = item.quantity
          }
          if (skus_in && skus_in.length > 0) {
            skus_in.forEach((sku) => {
              if (item.sku == sku) {
                ConditionalProductQuantity += item.quantity
                itemCounted = true
              }
            })
          }
          if (
            item.selling_plan_allocation &&
            item.selling_plan_allocation.price
          ) {
            isSubscriptionProduct = true
          }
          if (
            !itemCounted &&
            gift.conditions.variant_in_cart &&
            gift.conditions.variant_in_cart.length > 0
          ) {
            gift.conditions.variant_in_cart.forEach((variant) => {
              if (item.variant_id == variant) {
                ConditionalProductQuantity += item.quantity
              }
            })
          }
        })

        if (gift.conditions.cart_total) {
          if (gift.conditions.cart_total.operator == ">=") {
            if (cart.total_price < gift.conditions.cart_total.value) {
              giftConditionsMet = false
            }
          }
        }

        if (gift.conditions.cart_items) {
          if (gift.conditions.cart_items.operator == ">=") {
            if (cart.item_count < gift.conditions.cart_items.value) {
              giftConditionsMet = false
            }
          }
        }

        if (gift.conditions.skus_in && gift.conditions.skus_in.length > 0) {
          let skuInCart = false
          gift.conditions.skus_in.forEach((sku) => {
            let cartItems = cart.items

            cartItems.forEach((item) => {
              let productType = item.product_type
              if (
                InvalidProductType &&
                productType.toUpperCase() == InvalidProductType.toUpperCase()
              ) {
              } else if (
                item.sku &&
                item.sku.toUpperCase() == sku.toUpperCase()
              ) {
                let price = item.price / 100
                let pricetoCompare = gift.conditions.sku_single_item
                if (pricetoCompare.operator == ">") {
                  if (price > pricetoCompare.value) {
                    skuInCart = true
                  }
                }

                // skuInCart = true;
              }
            })
          })

          if (!skuInCart) {
            giftConditionsMet = false
          }
        } else if (
          gift.conditions.variant_in_cart &&
          gift.conditions.variant_in_cart.length > 0
        ) {
          giftConditionsMet = false
          gift.conditions.variant_in_cart.forEach((variant) => {
            cart.items.forEach((item) => {
              if (item.variant_id == variant) {
                giftConditionsMet = true
              }
            })
          })

          if (!giftConditionsMet) {
            giftConditionsMet = false
          }
        }

        if (
          gift.conditions.handle_in_cart &&
          gift.conditions.handle_in_cart.length > 0
        ) {
          let handleFound = false
          cart.items.forEach((item) => {
            if (gift.conditions.handle_in_cart.includes(item.handle)) {
              handleFound = true
            }
          })
          if (!handleFound) {
            giftConditionsMet = false
          }
        }

        // Combined-quantity condition: sum the quantity of every cart line that belongs
        // to the target product (matched by handle or product_id), across all flavors/variants.
        // The gift line itself is never counted so it can't keep itself alive.
        if (gift.conditions.product_quantity_total) {
          let cond = gift.conditions.product_quantity_total
          let targetHandles = cond.handles || (cond.handle ? [cond.handle] : [])
          let targetProductIds =
            cond.product_ids || (cond.product_id ? [cond.product_id] : [])
          let matchedQuantity = 0
          cart.items.forEach((item) => {
            if (item.variant_id == gift.variant_id) return
            // When only_one_time is set, ignore subscription lines (those carry a
            // selling_plan_allocation) so the gift only fires for one-time purchases.
            if (
              cond.only_one_time &&
              item.selling_plan_allocation &&
              item.selling_plan_allocation.price
            ) {
              return
            }
            let matchesHandle = targetHandles.includes(item.handle)
            let matchesProduct = targetProductIds.includes(item.product_id)
            if (matchesHandle || matchesProduct) {
              matchedQuantity += item.quantity
            }
          })
          let quantityConditionMet
          switch (cond.operator) {
            case ">=":
              quantityConditionMet = matchedQuantity >= cond.value
              break
            case ">":
              quantityConditionMet = matchedQuantity > cond.value
              break
            case "==":
              quantityConditionMet = matchedQuantity == cond.value
              break
            case "<=":
              quantityConditionMet = matchedQuantity <= cond.value
              break
            case "<":
              quantityConditionMet = matchedQuantity < cond.value
              break
            default:
              quantityConditionMet = false
          }
          if (!quantityConditionMet) {
            giftConditionsMet = false
          }
        }

        if (
          gift.conditions.isSubscriptionProduct == "yes" &&
          isSubscriptionProduct == false
        ) {
          giftConditionsMet = false
        }

        if (gift.match_quantity && ConditionalProductQuantity > 0) {
          gift.quantity_to_add = ConditionalProductQuantity
        }

        if (gift.conditions.never_add_when_item) {
          let neverAddWhenItem = gift.conditions.never_add_when_item
          let neverAddWhenItemInCart = false
          cart.items.forEach((item) => {
            if (neverAddWhenItem.includes(item.handle)) {
              neverAddWhenItemInCart = true
            }
          })
          if (neverAddWhenItemInCart) {
            giftConditionsMet = false
          }
        }
        // // hardcode checked for no free shake A/B Test
        // if (window.no_free_shake == true && gift.variant_id == 43022229602462) {
        //   giftConditionsMet = false;
        // }
        if (giftConditionsMet) {
          let productId = gift.conditions?.product_id?.[0]
          let productInCart = cart.items.find((e) => e.product_id == productId)

          let isAlreadyIngiftCartProducts = giftCartProducts.find(
            (e) => e.if_product_id == productId
          )

          if (productId && !isAlreadyIngiftCartProducts) {
            giftCartProducts.push({
              if_product_variant_id: productInCart.variant_id,
              if_product_id: productInCart.product_id,
              free_gift_variant_id: gift.variant_id,
              quantity: gift.quantity_to_add,
            })
          }
        }
        if (gift.variant_id) {
          if (giftConditionsMet && !giftInCart && !giftVariantInCart) {
            giftsToUpdate[gift.variant_id] = gift.quantity_to_add
          } else if (
            giftConditionsMet &&
            giftVariantInCart &&
            giftQuantityInCart != gift.quantity_to_add
          ) {
            giftsToUpdate[gift.variant_id] = gift.quantity_to_add
          } else if (!giftConditionsMet && giftInCart) {
            giftsToUpdate[gift.variant_id] = 0
          } else if (!giftConditionsMet && giftVariantInCart) {
            giftsToUpdate[gift.variant_id] = 0
          }
        }
      })

      if (giftsToUpdate && Object.keys(giftsToUpdate).length > 0) {
        let itemsToUpdate = {} 

        Object.keys(giftsToUpdate).forEach((key) => {
          let isRemoved = Cookies.get(`rrremoved_${key}`)
          if (isRemoved == "true") {
          } else {
            itemsToUpdate[key] = giftsToUpdate[key]
          }
        })

        let attributesData
        if (giftCartProducts.length > 0) {
          attributesData = {
            _free_gift_with_product: JSON.stringify(giftCartProducts),
          }
        }

        let itemsLength = Object.keys(itemsToUpdate).length

        if (
          itemsLength > 0 &&
          giftsToUpdate &&
          Object.keys(giftsToUpdate).length > 0
        ) {
          await this.bulktUpdateCart(itemsToUpdate, null, attributesData)
        } else {
          let attributesData = cartAttributes
          let _free_gift_with_product = cartAttributes?._free_gift_with_product
          if (
            _free_gift_with_product &&
            _free_gift_with_product.length > 0 &&
            giftCartProducts.length == 0
          ) {
            attributesData = {
              _free_gift_with_product: "",
            }
            await this.bulktUpdateCart({}, attributesData)
          }
        }
      }
    }

    if (!cart || !cart.items || cart.items.length == 0) {
      return
    }

    // let cartTotal = cart.total_price / 100;
    let hasResetWeekProduct = cart?.items?.find((item) => {
      return item.properties._reset_week
    })
    let has_reset_week_upsells = cart?.items?.filter((item) => {
      return item.properties._reset_week_upsell
    })

    if (!hasResetWeekProduct && has_reset_week_upsells.length > 0) {
      // Remove all reset week upsells if no reset week product is in the cart
      let itemsToUpdate = {}
      has_reset_week_upsells.forEach((item) => {
        itemsToUpdate[item.id] = 0
      })
      this.bulktUpdateCart(itemsToUpdate, null, {
        _reset_week_upsell: "",
      })
    }

    // L-Protien

    // let cartTotal = cart.total_price / 100;
    let hasLProteinProduct = cart?.items?.find((item) => {
      return item.properties._l_protein
    })
    let has_l_protein_upsells = cart?.items?.filter((item) => {
      return item.properties._l_protein_upsell
    })

    if (!hasLProteinProduct && has_l_protein_upsells.length > 0) {
      // Remove all reset week upsells if no reset week product is in the cart
      let itemsToUpdate = {}
      has_l_protein_upsells.forEach((item) => {
        itemsToUpdate[item.id] = 0
      })
      this.bulktUpdateCart(itemsToUpdate, null, {
        _l_protein_upsell: "",
      })
    }

    // Free Welcome Kit — auto-sync based on _free_welcome_kit property on parent items.
    // Add the kit to cart when a parent item carries the property; remove it when the parent leaves.
    // Toggle: set to false to disable the Free Welcome Kit gift (won't be added; removed if already present).
    const FREE_WELCOME_KIT_ENABLED = true
    const FREE_WELCOME_KIT_VARIANT_ID = 47948612665502
    // Products that qualify for the Free Welcome Kit on subscription only (first month only,
    // since the kit is added as a one-time line item, not part of the selling plan).
    const FREE_WELCOME_KIT_SUBSCRIPTION_PRODUCT_IDS = [8156423520414] // prolon-professional-program-2
    let hasWelcomeKitParent = cart?.items?.some(
      (item) =>
        (item.properties && item.properties._free_welcome_kit) ||
        (item.selling_plan_allocation &&
          FREE_WELCOME_KIT_SUBSCRIPTION_PRODUCT_IDS.includes(item.product_id))
    )
    let welcomeKitInCart = cart?.items?.find(
      (item) => item.variant_id == FREE_WELCOME_KIT_VARIANT_ID
    )

    if (!FREE_WELCOME_KIT_ENABLED) {
      // Gift disabled: never add it, and clean up any kit that's still in the cart.
      if (welcomeKitInCart) {
        await this.bulktUpdateCart({ [welcomeKitInCart.id]: 0 })
      }
    } else if (hasWelcomeKitParent && !welcomeKitInCart) {
      // Respect the user removing it (rrremoved_ cookie convention used by gift logic)
      let removedCookie = typeof Cookies !== "undefined"
        ? Cookies.get(`rrremoved_${FREE_WELCOME_KIT_VARIANT_ID}`)
        : null
      if (removedCookie !== "true") {
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  id: FREE_WELCOME_KIT_VARIANT_ID,
                  quantity: 1,
                  properties: { _free_welcome_kit_gift: true },
                },
              ],
            }),
          })
        } catch (e) {
          devLog("Error adding free welcome kit:", e)
        }
      }
    } else if (!hasWelcomeKitParent && welcomeKitInCart) {
      // Parent gone — remove the welcome kit
      await this.bulktUpdateCart({ [welcomeKitInCart.id]: 0 })
    }

    // Summer Giveaway — free Prolon water bottle with ANY order.
    // Added as soon as the cart holds one real product; removed when the cart has nothing left to gift with.
    // Toggle: set to false to end the giveaway (won't be added; removed if already in the cart).
    const SUMMER_GIVEAWAY_ENABLED = true
    const SUMMER_GIVEAWAY_VARIANT_ID = 42572832833718 // free-prolon-signature-bottle
    // Lines that don't count as "an order" on their own (paid shipping upgrade)
    const SUMMER_GIVEAWAY_IGNORED_VARIANT_IDS = [43035645640862]
    // Consumer promo only — carts built by the HCP provider portal carry the
    // HCP cart attribute (set by the portal's checkout flow); they never get
    // the free bottle, and any bottle already in such a cart is removed.
    const isHcpPortalCart = !!(cart?.attributes && cart.attributes.HCP)
    let giveawayBottleInCart = cart?.items?.find(
      (item) => item.variant_id == SUMMER_GIVEAWAY_VARIANT_ID
    )
    let hasGiveawayQualifyingItem = cart?.items?.some(
      (item) =>
        item.variant_id != SUMMER_GIVEAWAY_VARIANT_ID &&
        !SUMMER_GIVEAWAY_IGNORED_VARIANT_IDS.includes(item.variant_id)
    )

    if (!SUMMER_GIVEAWAY_ENABLED || isHcpPortalCart) {
      // Giveaway over: never add it, and clean up any bottle still in the cart.
      if (giveawayBottleInCart) {
        await this.bulktUpdateCart({ [SUMMER_GIVEAWAY_VARIANT_ID]: 0 })
      }
    } else if (hasGiveawayQualifyingItem && !giveawayBottleInCart) {
      // Respect the shopper removing it (rrremoved_ cookie convention used by gift logic)
      let giveawayRemoved =
        typeof Cookies !== "undefined"
          ? Cookies.get(`rrremoved_${SUMMER_GIVEAWAY_VARIANT_ID}`)
          : null
      if (giveawayRemoved !== "true") {
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  id: SUMMER_GIVEAWAY_VARIANT_ID,
                  quantity: 1,
                  properties: { _summer_giveaway_gift: true },
                },
              ],
            }),
          })
        } catch (e) {
          devLog("Error adding Summer Giveaway water bottle:", e)
        }
      }
    } else if (!hasGiveawayQualifyingItem && giveawayBottleInCart) {
      // Nothing left to gift with — take the bottle back out
      await this.bulktUpdateCart({ [SUMMER_GIVEAWAY_VARIANT_ID]: 0 })
    } else if (giveawayBottleInCart && giveawayBottleInCart.quantity > 1) {
      // One free bottle per order
      await this.bulktUpdateCart({ [SUMMER_GIVEAWAY_VARIANT_ID]: 1 })
    }
  },
  async ProcessCartGifts() {
    // Prevent re-entrant calls (e.g. when bulktUpdateCart triggers getCart again)
    if (this.state._processingGifts) {
      return
    }
    this.state._processingGifts = true

    try {
      // Add or Remove Cart Gifts based on allowedGifts
      if (this.state.cartState && this.state.cartState.length > 0) {
        let cart = this.state.cartState[0]

        // Auto-remove expedited shipping if it's the only item left in the cart
        const expeditedShippingVariantId = 43035645640862
        if (cart && cart.items && cart.items.length > 0) {
          let nonExpedited = cart.items.filter((ci) => ci.variant_id !== expeditedShippingVariantId)
          let expeditedItem = cart.items.find((ci) => ci.variant_id === expeditedShippingVariantId)
          if (nonExpedited.length === 0 && expeditedItem) {
            devLog("Auto-removing expedited shipping — no other products in cart")
            await this.bulktUpdateCart({ [expeditedItem.key]: 0 })
            // Refresh cart data after gift update so UI reflects changes immediately
            await this._refreshCartData()
            return
          }
        }

        await this.checkRecommendedUpsells(cart)
        try {
          await this.processAllowedGifts(cart)
        } catch (e) {
          // Never let a gift-rule error skip the refresh below — that used to leave
          // state.updatingCart stuck true, which disables REMOVE / +- on every line.
          devLog("Error processing cart gifts:", e)
        }
        // Refresh cart data after gift processing so UI reflects any gift additions/removals immediately
        await this._refreshCartData()
      }
    } finally {
      this.state._processingGifts = false
      // Safety net: the cart must never be left in the "updating" (disabled) state.
      this.state.updatingCart = false
    }
  },
  checkCart() {
    return this.ProcessCartGifts()
  },
  clearCart() {
    devLog(`Clearing Cart`)
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.json()
      })
      .then((data) => {
        this.getCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },
  allowedVariants(gift) {
    let collection_handle = gift.collection_handle
    let allowed_variants = []
    if (collection_handle == "free-gifts-cart") {
      let products = this.state.freeGiftsCollection
      if (products && products.length > 0) {
        products.forEach((product) => {
          if (product.variants && product.variants.length > 0) {
            product.variants.forEach((variant) => {
              allowed_variants.push(variant.id)
            })
          }
        })
      }
    }

    return allowed_variants || []
  },
})

const slideCartState = Vue.reactive({
  hidden: true,
})

const toggleCart = {
  openCart() {
    slideCartState.hidden = !slideCartState.hidden
    menuState.hidden = true

    if (slideCartState.hidden) {
      document.body.classList.remove("slide-cart-open")
    } else {
      document.body.classList.add("slide-cart-open")
    }
  },
  showCart() {
    //SuperCart.ShowCartfn();
    slideCartState.hidden = false
    menuState.hidden = true
    document.body.classList.add("slide-cart-open")
    store.getCart()
    if (window.posthog) {
      window.posthog.capture("view_slide_cart")
    }
  },
}

const menuState = Vue.reactive({
  hidden: true,
})

const toggleMenu = {
  openMenu() {
    menuState.hidden = !menuState.hidden
    slideCartState.hidden = true
  },
}

const toggleClose = {
  closeAll() {
    slideCartState.hidden = true
    menuState.hidden = true
    document.body.classList.remove("slide-cart-open")
  },
}

const freeShippingSettings = {
  freeShippingThreshold: 20000,
  freeShippingMessage: "FREE SHIPPING AT _value_",
  remainingMessage: "YOU'RE _value_ AWAY",
  successMessage: "🎉 You’ve earned free shipping!",
}

//   window.API_URL = "http://localhost:1337/";
window.API_URL = "https://prolon-pro.herokuapp.com/"
window.local_host = localStorage.getItem("doLocal")
if (local_host == 1) {
  window.API_URL = "http://localhost:1337/"
}

if (document.querySelector("#cart-with-header")) {
  const headerCart = Vue.createApp({
    delimiters: ["${", "}"],
    data() {
      let providerCode = localStorage.getItem("provider_code")
      let discountCode = getParam("discount") || local_discount_code || ""
      if ((discountCode && discountCode == "null") || discountCode == null) {
        discountCode = ""
      }
      if (providerCode && providerCode == "null") {
        providerCode = ""
      }

      if (providerCode) {
        // freeShippingSettings.freeShippingThreshold = 10000;
      }
      return {
        cartData: store.state.cartState,
        scrollY: 0,
        custom_loading: false,
        hasValidStripeProducts: true,
        isOpeningMenu: false,
        checkoutLoading: false,
        discountCode: discountCode,
        allowedGifts: store.state.allowedGifts,
        provider_code: providerCode,
        addingDiscount: false,
        resetUpsellLoading: false,

        new_year_bundle: {
          id: 8336799989918,
          loading: false,
          variants: [
            {
              id: 45631937183902,
            },
          ],
          handle: "longevity-nutrition-kit",
        },
        new_year_bundle_v2: {
          id: 8336799989918,
          loading: false,
          variants: [
            {
              id: 45631937183902,
            },
          ],
          handle: "longevity-nutrition-kit",
        },
        prolon_protein: {
          id: null,
          loading: false,
          variants: [
            {
              id: 46498877276318,
            },
          ],
          handle: "prolon-longevity-protein",
        },
        ShowDiscountFailedMessage: false,
         milestones: [
          // {
          //   id: "free_gift",
          //   amount: 100, 
          //   label: "Free Gift",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/gift_1.png?v=1762806712",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/gift_2.png?v=1762806751",
          //   achievedMessage: "🎉 You've earned a free gift!",
          //   pendingMessage:
          //     "${remainingAmount} away from free gift",
          //   beforeText: "Free Gift —",
          //   afterText: "on orders over $99",
          // }, 
          {
            id: "free_shipping",
            amount: 200,
            label: "Free Shipping",
            icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/free-shipping.png?v=1751369542",
            achievedIcon:
              "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/free-shipping.png?v=1751369542",
            achievedMessage: "🎉 You've earned free shipping!",
            pendingMessage:
              "${remainingAmount} away from free shipping",
            beforeText: "Free Shipping —",
            afterText: "on orders over $200",
          },
          // {
          //   id: "discount_30",
          //   amount: 250, 
          //   label: "Save 30%",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_4.png?v=1750420498",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/30OFF.png?v=1750452929",
          //   achievedMessage: "🎉 You have earned 30% discount!",
          //   pendingMessage: "${remainingAmount} away from 30% discount",
          //   beforeText: "Save 30% —",
          //   afterText: "on orders over $250",
          // },
          // {
          //   id: "discount_35", 
          //   amount: 350, 
          //   label: "Save 35%",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/35OFF-removebg-preview.png?v=1764160912",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/35OFF_achived-removebg-preview.png?v=1764160912", 
          //   achievedMessage: "🎉 You have earned 35% discount!",
          //   pendingMessage: "${remainingAmount} away from 35% discount",
          //   beforeText: "Save 35% —",
          //   afterText: "on orders over $350",
          // },
        ],    
        expeditedShippingEnabled: false,
        giftRemovalPopup: {
          show: false,
          item: null,
          index: null,
        },
      }
    },
    methods: {
      isNextMilestone(milestone) {
        if (!milestone || !milestone.id) {
          return false
        }

        if (this.allMilestonesAchieved()) {
          return false
        }

        let cartTotal = this.original_total_price / 100
        let unachievedMilestones = this.milestones
          .filter((m) => !this.milestoneAchieved(m))
          .sort((a, b) => a.amount - b.amount)

        if (unachievedMilestones.length > 0) {
          return milestone.id === unachievedMilestones[0].id
        }

        return false
      },
      allMilestonesAchieved() {
        return this.milestones.every((m) => this.milestoneAchieved(m))
      },

      getMilestoneDiscountPercent() {
        let cartTotal = this.original_total_price / 100

        if (cartTotal >= 300) {
          return 30
        } else if (cartTotal >= 259) {
          return 25
        } else if (cartTotal >= 199) {
          return 20
        } else if (cartTotal >= 149) {
          return 15
        }

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return 30 // Default discount for provider code
        }

        return 0 // No discount
      },

      getMilestoneDiscount() {
        let discountPercent = this.getMilestoneDiscountPercent()

        if (discountPercent > 0) {
          return this.original_total_price * (discountPercent / 100)
        }

        return 0
      },

      milestoneAchieved(milestone) {
        let cartTotal = this.original_total_price / 100
        let amount = milestone.amount
        if (amount == 0) {
          return false
        }

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return true // If provider code is set, milestone is considered achieved
        }
        if (cartTotal >= amount) {
          return true
        } else {
          return false
        }
      },
      calculateProgress(currentAmount, shift) {
        // Dynamically find the highest milestone amount
        const maxThreshold = Math.max(...this.milestones.map((m) => m.amount))
        const minThreshold = 0 // Set minimum threshold to $100

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return 100 // If provider code is set, progress is always 100%
        }

        if (currentAmount <= 0) {
          return 0 // Progress is 0% if no amount is spent
        } else if (currentAmount < minThreshold) {
          // Show minimal progress for amounts under $100
          return (currentAmount / maxThreshold) * 15 // Show only up to 15% of progress bar
        } else if (currentAmount < maxThreshold) {
          // Calculate percentage from $100 to max threshold
          const adjustedAmount = currentAmount - minThreshold
          const adjustedMax = maxThreshold - minThreshold
          // Scale from 15% to 100% for the remaining range
          return 15 + (adjustedAmount / adjustedMax) * 85
        } else {
          if (shift) {
            return 97 // Slight adjustment to position the marker
          }
          return 100 // Progress is 100% if max threshold or more is spent
        }
      },

      getMiniDescription(id) {
        return (
          (window.gift_products_mini_description &&
            window.gift_products_mini_description[id]) ||
          ""
        )
      },
      bundle_items(item) {
        let finalHtml = ""
        try {
          let shopify_cartItems = store.state.shopify_cart
          let shopifyItem = shopify_cartItems.find(
            (i) => i.handle === item.handle
          )
          let bundleItems = shopifyItem.bundle_items
          if (bundleItems && bundleItems.length > 0) {
            let bundleQuantityString =
              shopifyItem?.custom_metafields?.prolon_bundle_item_quantity
            let bundleQuantity
            if (bundleQuantityString) {
              bundleQuantity = bundleQuantityString.split(",")
            }
            //  for loop for bundle items and bundle quantity
            for (let i = 0; i < bundleItems.length; i++) {
              let currentQuantity = bundleQuantity[i]
              let currentBundleItem = bundleItems[i]
              let bundleTitle = currentBundleItem.title
              let bundleName = currentBundleItem?.name?.replace(
                " - " + bundleTitle,
                ""
              )
              let bundleImage = currentBundleItem.featured_image?.src
              let bundleImageHtml = `<img src="${bundleImage}" class="w-8 h-8 object-cover" alt="">`
              if (!bundleImage) {
                bundleImageHtml = `<div class="w-8 h-8 object-cover" >${window.placeholder_image_svg}</div>`
              }

              finalHtml += `<div class="flex flex-row justify-between items-center py-2 pl-2 md:pl-5">
          <div class="flex flex-row justify-start items-center">
          <div class="w-8 h-8 border border-solid border-1 rounded">
              ${bundleImageHtml}
          </div>   
          <div class="flex flex-col justify-center items-start">
          <p class="text-[12px] pl-4 font-medium ">
          <span class="block font-semibold">
          ${currentQuantity} x ${bundleName}
          </span>
          <small>${bundleTitle}</small>
          </p>
          
          </div>
          </div></div>
          `
            }
          }
        } catch (ex) {}
        return finalHtml
      },
      bundle_component_length(item) {
        let shopify_cartItems = store.state.shopify_cart
        if (!shopify_cartItems) {
          return ""
        }
        let shopifyItem = shopify_cartItems.find(
          (i) => i.handle === item.handle
        ) 
        let bundleItems = shopifyItem?.bundle_components
        if (bundleItems && bundleItems.length > 0) {
          return bundleItems.length
        } else {
          return 0
        }
      },
      bundle_components(item) {
        let finalHtml = "" 
        try {
          let shopify_cartItems = store.state.shopify_cart
          let shopifyItem = shopify_cartItems.find(
            (i) => i.handle === item.handle
          )
          let bundleItems = shopifyItem.bundle_components
          if (bundleItems && bundleItems.length > 0) {
            //  for loop for bundle items and bundle quantity
            for (let component of bundleItems) {
              let currentQuantity = component.quantity
              let currentBundleItem = component
              let bundleTitle = currentBundleItem.variant_title.replace(
                "Default Title",
                ""
              )
              let bundleName = currentBundleItem.product_title
              let bundleImage = currentBundleItem.featured_image
              let bundleImageHtml = `<img src="${bundleImage}" class="w-8 h-8 object-cover" alt="">`
              if (!bundleImage) {
                bundleImageHtml = `<div class="w-8 h-8 object-cover" >${window.placeholder_image_svg}</div>`
              }

              finalHtml += `<div class="flex flex-row justify-between items-center py-2 pl-2 md:pl-5">
          <div class="flex flex-row justify-start items-center">
          <div class="w-8 h-8 border border-solid border-1 rounded">
              ${bundleImageHtml}
          </div>   
          <div class="flex flex-col justify-center items-start">
          <p class="text-[12px] pl-4 font-medium ">
          <span class="block font-semibold">
          ${currentQuantity} x ${bundleName}
          </span>
          <small>${bundleTitle}</small>
          </p>
          
          </div>
          </div></div>
          `
            }
          }
        } catch (ex) {}
        return finalHtml
      },
      clearProviderCode() {
        localStorage.setItem("provider_code", null)
        Cookies.set("provider_code", null, { expires: 700 })
        this.provider_code = null
        this.discount_code = null
      },
      toggleSlideCart() {
        toggleCart.openCart()
      },
      getUpsellTagLines(handle) {
        let tagsLines = {
          "fasting-shake-upsell": [
            "Fasting Shake: Fuel Your Body, Not Your Hunger",
            "Fasting Shake: Elevate Your Nutrition Game",
            "Fasting Shake: Nourish Without Guilt",
            "Fasting Shake: Aging Slower, Feeling Better",
          ],
          "prolon-20-off": ["Continue your longevity journey"],
          "fast-bar-off": [
            "Fasting Bars: The Delicious Way to Extend Your Fasting Window",
          ],
        }

        return tagsLines[handle]
      },
      toggleMenu() {
        this.isOpeningMenu = menuState.hidden

        setTimeout(() => {
          toggleMenu.openMenu()
        }, 100)
      },
      closeAllDrawers() {
        this.isOpeningMenu = false
        toggleClose.closeAll()
      },
      removeItem(item, index, confirmed) {
        // Intercept free-gift removal so the shopper knows it won't come back today
        if (!confirmed && item && item.price === 0 && !item.removing && !this.giftRemovalPopup.show) {
          this.giftRemovalPopup = { show: true, item, index }
          return
        }

        item.removing = true
        devLog({ index })
        if (item.price === 0) {
          try {
            Cookies.set(`rrremoved_${item.id}`, "true", { expires: 1 })
          } catch (ex) {
            console.error("Error setting cookie:", ex)
          }
        }

        // Find free gifts that depend on this item being in cart so we can remove them immediately
        let giftVariantIdsToRemove = []
        let cart = store.state.cartState[0]
        const expeditedShippingVariantId = 43035645640862
        if (cart && cart.items) {
          let remainingItems = cart.items.filter((ci, ci_index) => ci_index !== index)

          // Auto-remove expedited shipping if only it remains after this removal
          let nonExpeditedRemaining = remainingItems.filter((ci) => ci.variant_id !== expeditedShippingVariantId)
          if (nonExpeditedRemaining.length === 0) {
            let expeditedItem = remainingItems.find((ci) => ci.variant_id === expeditedShippingVariantId)
            if (expeditedItem) {
              giftVariantIdsToRemove.push(expeditedShippingVariantId)
              expeditedItem.removing = true
              this.expeditedShippingEnabled = false
            }
          }

          store.state.allowedGifts.forEach((gift) => {
            if (!gift.enabled) return
            let giftInCart = cart.items.find((ci) => ci.variant_id == gift.variant_id)
            if (!giftInCart) return

            let wouldStillQualify = true

            // Check handle_in_cart condition
            if (gift.conditions.handle_in_cart && gift.conditions.handle_in_cart.length > 0) {
              let handleFound = remainingItems.some((ci) => gift.conditions.handle_in_cart.includes(ci.handle))
              if (!handleFound) wouldStillQualify = false
            }

            // Check skus_in condition
            if (gift.conditions.skus_in && gift.conditions.skus_in.length > 0 && gift.conditions.sku_single_item) {
              let skuFound = false
              remainingItems.forEach((ci) => {
                gift.conditions.skus_in.forEach((sku) => {
                  if (ci.sku && ci.sku.toUpperCase() === sku.toUpperCase()) {
                    let price = ci.price / 100
                    if (gift.conditions.sku_single_item.operator === ">" && price > gift.conditions.sku_single_item.value) {
                      skuFound = true
                    }
                  }
                })
              })
              if (!skuFound) wouldStillQualify = false
            }

            // Check variant_in_cart condition
            if (gift.conditions.variant_in_cart && gift.conditions.variant_in_cart.length > 0 && !gift.conditions.skus_in) {
              let variantFound = remainingItems.some((ci) => gift.conditions.variant_in_cart.includes(ci.variant_id))
              if (!variantFound) wouldStillQualify = false
            }

            // Check isSubscriptionProduct condition
            if (gift.conditions.isSubscriptionProduct === "yes") {
              let hasSubscription = remainingItems.some((ci) => ci.selling_plan_allocation && ci.selling_plan_allocation.price)
              if (!hasSubscription) wouldStillQualify = false
            }

            // Check cart_total condition against remaining items
            if (gift.conditions.cart_total) {
              let remainingTotal = remainingItems.reduce((sum, ci) => sum + ci.final_line_price, 0)
              if (gift.conditions.cart_total.operator === ">=" && remainingTotal < gift.conditions.cart_total.value) {
                wouldStillQualify = false
              }
            }

            // Check product_quantity_total condition against remaining items
            if (gift.conditions.product_quantity_total) {
              let cond = gift.conditions.product_quantity_total
              let targetHandles = cond.handles || (cond.handle ? [cond.handle] : [])
              let targetProductIds =
                cond.product_ids || (cond.product_id ? [cond.product_id] : [])
              let remainingQty = 0
              remainingItems.forEach((ci) => {
                if (ci.variant_id == gift.variant_id) return
                let matchesHandle = targetHandles.includes(ci.handle)
                let matchesProduct = targetProductIds.includes(ci.product_id)
                if (matchesHandle || matchesProduct) {
                  remainingQty += ci.quantity
                }
              })
              let stillMet
              switch (cond.operator) {
                case ">=": stillMet = remainingQty >= cond.value; break
                case ">": stillMet = remainingQty > cond.value; break
                case "==": stillMet = remainingQty == cond.value; break
                case "<=": stillMet = remainingQty <= cond.value; break
                case "<": stillMet = remainingQty < cond.value; break
                default: stillMet = false
              }
              if (!stillMet) wouldStillQualify = false
            }

            if (!wouldStillQualify) {
              giftVariantIdsToRemove.push(gift.variant_id)
              // Optimistically hide the gift item from UI
              giftInCart.removing = true
            }
          })
        }

        // One removal request for every case. Two things this guards against, both of
        // which showed up as "REMOVE does nothing while the row spins forever":
        //   1. Target the line item KEY (exactly what the working +/- buttons send).
        //      `index` comes from the rendered (filtered + reversed) list, so it drifts
        //      out of sync with the real cart lines as soon as gift logic adds a line.
        //   2. Never leave the row spinning: a non-OK response, a network error or a
        //      request that never comes back all clear the spinner, release the cart and
        //      log the real status instead of failing silently.
        let requestUrl, requestBody
        if (giftVariantIdsToRemove.length > 0) {
          let updates = {}
          updates[item.key] = 0
          giftVariantIdsToRemove.forEach((variantId) => {
            let giftItem = cart.items.find((ci) => ci.variant_id == variantId)
            if (giftItem) {
              updates[giftItem.key] = 0
            }
          })
          requestUrl = "/cart/update.js"
          requestBody = { updates: updates }
        } else {
          requestUrl = "/cart/change.js"
          requestBody = item.key
            ? { id: item.key, quantity: 0 }
            : { line: index + 1, quantity: 0 }
        }

        store.setCartLoading()

        let removalController =
          typeof AbortController !== "undefined" ? new AbortController() : null
        let removalTimeout = setTimeout(() => {
          if (removalController) removalController.abort()
        }, 12000)

        let releaseRow = () => {
          clearTimeout(removalTimeout)
          item.removing = false
          store.state.updatingCart = false
        }

        fetch(requestUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          signal: removalController ? removalController.signal : undefined,
        })
          .then(async (response) => {
            if (!response.ok) {
              let detail = ""
              try {
                detail = (await response.text()).slice(0, 300)
              } catch (e) {}
              throw new Error(
                `${requestUrl} ${response.status} ${response.statusText} ${detail}`
              )
            }
            return response.json()
          })
          .then((data) => {
            clearTimeout(removalTimeout)
            store.getCart()
          })
          .catch((error) => {
            // Loud on purpose — a swallowed failure here is invisible to the shopper
            console.error(
              "[slide-cart] remove failed",
              { url: requestUrl, body: requestBody, key: item.key, line: index },
              error
            )
            releaseRow()
          })
      },

      confirmGiftRemoval() {
        const pending = this.giftRemovalPopup
        const item = pending.item
        const index = pending.index
        this.giftRemovalPopup = { show: false, item: null, index: null }
        if (item) {
          this.removeItem(item, index, true)
        }
      },
      cancelGiftRemoval() {
        this.giftRemovalPopup = { show: false, item: null, index: null }
      },

      decrement(item, index) {
        let updateQuantity = item.quantity - 1
        item.quantity = updateQuantity
        const data = {
          id: item.key,
          quantity: updateQuantity,
        }

        item.loading_minus = true
        store.setCartLoading()
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
            item.loading_minus = false
          })
      },
      increment(item, index) {
        let updateQuantity = item.quantity + 1
        item.quantity = updateQuantity
        const data = {
          id: item.key,
          quantity: updateQuantity,
        }

        item.loading_plus = true
        store.setCartLoading()
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
            item.loading_plus = false
          })
      },

      money(value) {
        if (!value) return "$0.00"
        return "$" + (value / 100).toFixed(2)
      },
      isInCart(item) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i.product_id === item.id)
        )
      },
      isInCartByHandle(item) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i?.handle?.includes(item.handle))
        )
      },
      isVariantInCart(variant_id) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i.variant_id === variant_id)
        )
      },
      isAllUpsellinCart() {
        if (this.cartData.length > 0) {
          let cartItems = this.cartData[0].items
          let upsellItems = store.state.recommendedCollection
          let upsellInCart = 0
          for (let i = 0; i < cartItems.length; i++) {
            for (let j = 0; j < upsellItems.length; j++) {
              if (cartItems[i].product_id == upsellItems[j].id) {
                upsellInCart++
              }
            }
          }
          if (upsellInCart == upsellItems.length) {
            return true
          } else {
            return false
          }
        }
      },

      addToCart(item) {
        item.loading = true
        store.addToCart(item.variants[0].id, 1)
        setTimeout(() => {
          item.loading = false
        }, 2000)
      },

      // ----- SUMMER50 cross-sell: Reset 1-Day Kit at 50% off -----
      // Card markup + copy live in snippets/king-cart-reset-upsell.liquid.
      // SUMMER50 is scoped to this product in the admin, so applying it only ever
      // discounts the Reset line — never the rest of the cart.
      resetUpsellInCart() {
        return !!(
          this.cart &&
          this.cart.items &&
          this.cart.items.some((i) => i.handle === "prolon-reset")
        )
      },
      addResetUpsell(variantId) {
        if (this.resetUpsellLoading || !variantId) return
        this.resetUpsellLoading = true

        // Apply the code first so the discount is already on the line the moment it
        // lands; the add-to-cart runs either way if the discount call fails.
        fetch("/discount/SUMMER50?redirect=/cart.js", {
          credentials: "same-origin",
        })
          .catch(() => {})
          .then(() => {
            store.addToCartWithProperties({
              id: variantId,
              quantity: 1,
              properties: { upsell: true },
              cb: () => {
                this.resetUpsellLoading = false
              },
            })
          })

        // Safety net so the button can never stay stuck in its loading state.
        setTimeout(() => {
          this.resetUpsellLoading = false
        }, 6000)
      },
      addToCartWithVariantId(variant_id) {
        this.custom_loading = true
        store.addToCart(variant_id, 1, null, (response) => {
          // this.custom_loading = false;
          store.getCart()
        })
        setTimeout(() => {
          this.custom_loading = false
        }, 2000)
      },
      ABAddToCartUpsell() {
        // Check which upsell type to use based on window.change_upsell
        const upsellType = "prolon-longevity-protein" //window.change_upsell || 'longevity-nutrition-kit'; 
        
        if (upsellType === 'prolon-longevity-protein') {
          // Use prolon_protein configuration
          this.UpsellAddToCart(this.prolon_protein);
        } else {
          // Default to longevity-nutrition-kit logic
          let Xprovider_code = this.provider_code;
          
          if (Xprovider_code && Xprovider_code != "") {
            this.UpsellAddToCart(this.new_year_bundle_v2);
          } else {
            this.UpsellAddToCart(this.new_year_bundle);
          }
        }
        return;
      },
      UpsellAddToCart(item, type) {
        item.loading = true

        let props = {
          _upsell: true,
        }

        if (type == "free_gift") {
          props = {
            _free_gift: "yes",
            _above_total: window.cart_gift.threshold,
            _with_discount: "free-gifts",
            // _mystery_gift: 'yes',
          }
        }

        store.addToCartWithProperties({
          id: item.variants[0].id,
          quantity: 1,
          properties: props,
          cb: (response) => {
            item.loading = false
          },
        })
      },
      toggleExpeditedShipping() {
        this.expeditedShippingEnabled = !this.expeditedShippingEnabled
        const expeditedShippingVariantId = 43035645640862

        if (this.expeditedShippingEnabled) {
          // Add expedited shipping to cart
          store.addToCart(expeditedShippingVariantId, 1, null, (response) => {
            devLog("Expedited shipping added")
          })
        } else {
          // Remove expedited shipping from cart
          const cartItem = this.cart?.items?.find(
            (item) => item.variant_id === expeditedShippingVariantId
          )
          if (cartItem) {
            store.changeQuantity(cartItem.key, 0)
          }
        }
      },
      clearCart() {
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
          })
      },

      selling_planName(item) {
        if (item.selling_plan_allocation) {
          return item.selling_plan_allocation.selling_plan.name
        } else {
          return null
        }
      },
      scrollUpdate(e) {
        this.scrollY = window.scrollY
      },
      async gotoCheckout(discountCode) {
        try {
          let hcp_status = await this.checkHCPCode(discountCode)
          if (hcp_status && hcp_status == "ok") {
            // redirecting to stripe checkout
          } else {
            // redirecting to shopify checkout
            if (discountCode && discountCode != "") {
              this.applyDiscount()
            } else {
              window.location.href = "/checkout"
            }
          }
        } catch (e) {
          window.location.href = "/checkout"
        }
      },
      openCheckout() {
        let discountCode = this.provider_code
        if (
          !discountCode ||
          discountCode == "" ||
          discountCode == null ||
          discountCode == "null"
        ) {
          discountCode = this.discountCode
        }
        this.gotoCheckout(discountCode)
        this.checkoutLoading = true
        this.$refs.checkoutBtnText.innerHTML = "Processing ..."
        setTimeout(() => {
          //  this.checkoutLoading=false;
          this.$refs.checkoutBtnText.innerHTML = "Redirecting to Checkout ..."
        }, 1500)
        setTimeout(() => {
          //  $('body').addClass('opacity-0 transition duration-500');
        }, 1500)
        setTimeout(() => {
          this.checkoutLoading = false
        }, 8000)
      },
      async applyDiscount() {
        let discountCode = this.discountCode
        if (discountCode) {
          this.addingDiscount = true

          try {
            const response = await fetch(
              "https://prolon-pro.herokuapp.com/stores/lookup",
              {
                method: "GET",
                headers: {
                  accesstoken: "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",
                  shopname: "prolon-fmd-2020",
                  discount: discountCode,
                },
              }
            )

            if (!response.ok) {
              throw new Error("Network response was not ok")
            }

            const data = await response.json()
            devLog(data)

            if (data && data.id) {
              location.href = "/checkout?discount=" + discountCode
            } else {
              this.ShowDiscountFailedMessage = true
              this.addingDiscount = false
              setTimeout(() => {
                this.ShowDiscountFailedMessage = false
              }, 3000)
            }
          } catch (error) {
            devLog(error)
            this.ShowDiscountFailedMessage = true
            this.addingDiscount = false
            setTimeout(() => {
              this.ShowDiscountFailedMessage = false
            }, 3000)
          }
        } else {
          this.ShowDiscountFailedMessage = true
          setTimeout(() => {
            this.ShowDiscountFailedMessage = false
          }, 3000)
          // alert("Please enter a discount code");
          this.addingDiscount = false
        }
      },

      async checkHCPCode() {
        let code
        let patientDiscountcode = this.discountCode
        if (
          !code ||
          code == "" ||
          code == null ||
          code == undefined ||
          code == "null"
        ) {
          code = this.provider_code
        }
        if (
          !code ||
          code == "" ||
          code == null ||
          code == "null" ||
          code == undefined ||
          code == "undefined"
        ) {
          code = this.discountCode
        }
        if (
          !code ||
          code == "" ||
          code == null ||
          code == "null" ||
          code == undefined ||
          code == "undefined"
        ) {
          return null
        }

        if (code && code != "" && this.hasValidStripeProducts) {
          try {
            let codeStatusData = await fetch(
              `${API_URL}stores/hcp-lookup?hcp_code=${code}`
            )
            let codeStatus = await codeStatusData.json()

            if (
              codeStatus &&
              codeStatus.status &&
              (codeStatus.stripe_connect ||
                codeStatus?.customer?.provider_type == "no_commission")
            ) {
              let cart = this.cart
              let discountcode = code
              let shop = Shopify.shop || "prolon-fmd-2020.myshopify.com"
              // if(patientDiscountcode && patientDiscountcode!='' && patientDiscountcode!=code){
              //   discountcode+=`,${patientDiscountcode}`
              // }
              let accountId = codeStatus?.stripe_connect?.account_id

              if (codeStatus?.customer?.provider_type == "no_commission") {
                accountId = "no_commission"
              }
              let data = {
                stripe_connect_account_id: accountId,
                hcp_code: discountcode,
                ...cart,
              }

              // let _url = `${API_URL}stores/stripe/create-checkout-session?shop=${shop}`;

              if (
                codeStatus &&
                (codeStatus.stripe_connected ||
                  codeStatus?.customer?.provider_type == "no_commission")
              ) {
                let url = `/pages/secure-checkout?secure_code=${btoa(
                  accountId
                )}`
                location.href = url
                return "ok"
              }

              let _url = `${API_URL}stores/stripe/create-checkout-session?shop=${shop}`
              let only_klarna = getParam("only_klarna")
              if (only_klarna == "1") {
                _url += "&only_allow_klarna=1"
              } else {
                _url += "&with_klarna=1"
              }

              let response
              try {
                const fetchResponse = await fetch(_url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                  },
                  body: JSON.stringify(data),
                })

                if (!fetchResponse.ok) {
                  throw new Error(`HTTP error! Status: ${fetchResponse.status}`)
                }

                response = await fetchResponse.json()
              } catch (error) {
                console.error("Fetch error:", error)
              }

              if (response) {
                if (response.url) {
                  fetch("/cart/clear").then((response) => {
                    devLog("cart cleared")
                  })

                  window.location = response.url
                  return "ok"
                } else {
                  devLog("stripe-connect-error", response)
                  this.checkoutLoading = false
                  return null
                }
              } else {
                this.checkoutLoading = false
                return null
              }
            } else {
              this.checkoutLoading = false
              return null
            }
          } catch (e) {
            return null
          }
        }
      },
      getLinePrice(item) {
        if (item.properties && item.properties._price) {
          return item.properties._price * item.quantity
        }
        return item.final_line_price
      },
    },
    computed: {
      changeUpsellType() {
        // Check window variable for upsell type, similar to free_prolon_gift pattern
        return "prolon-longevity-protein" //window.change_upsell || 'longevity-nutrition-kit';
      },
      shop_now_link() {
        if (this.provider_code) {
          return `/products/prolon-professionals?hcp=${this.provider_code}`
        }
        return `/collections/all`
      },
      maxAmount() {
        return Math.max(...this.milestones.map((m) => m.amount))
      },
      gifts() {
        return store.state.allowedGifts.filter(
          (gift) => gift.enabled && gift.isDisplay
        )
      },

      isGiftInCart() {
        // const remainingGifts = this.gifts.filter((gift) => gift.targetValue > this.orderValue);
        const lastAchievedGift =
          this.gifts?.find((gift) => gift.type == "choose_gift") || null
        let allowed_variants = store.allowedVariants(lastAchievedGift)
        if (allowed_variants && allowed_variants.length > 0) {
          let isGiftInCart = 0
          allowed_variants.forEach((variant) => {
            let variantInCart = this.cartData[0].items.find(
              (item) => item.variant_id == variant
            )
            if (variantInCart) {
              isGiftInCart += variantInCart.quantity
            }
          })
          return isGiftInCart >= 1 ? true : false
        }
      },
      freeGiftsAchieved() {
        // const remainingGifts = this.gifts?.filter((gift) => gift.targetValue > this.orderValue) || [];
        // if (remainingGifts.length === 0) {
        //   return true;
        // }
        let hasSubscriptionProduct = false
        let prolonSKUs = [
          "PR001",
          "PR002",
          "PR039",
          "PR001-RKBUNDLE",
          "PR002-RKBUNDLE",
          "PR039-RKBUNDLE",
          "PR039-3Boxbundle",
          "PR004",
          "PR039-PNK",
          "PR001-2BOX",
          "PR002-2BOX",
          "PR0039-2BOX",
          "PR001-3BOX",
          "PR002-3BOX",
          "PR0039-3BOX",
          "4boxbulk",
          "PR039-4Boxbundle",
          "3boxbulk",
          "HOLIDAY-BUNDLE",
          "longevity-bundle",
          "if-bundle",
        ]
        // check if cart has subscription product also if cart has prolon product
        this.cartData?.[0]?.items?.forEach((item) => {
          if (
            item?.selling_plan_allocation &&
            item?.selling_plan_allocation?.price &&
            prolonSKUs.includes(item.sku)
          ) {
            hasSubscriptionProduct = true
          }
        })

        if (hasSubscriptionProduct) {
          return true
        }
        return false

        // const lastAchievedGift = this.gifts[this.gifts?.length - 1];

        // const nextTargetValue = remainingGifts[0].targetValue;
        // let remainingValue = nextTargetValue - this.orderValue;
        // remainingValue = remainingValue.toFixed(2);

        return remainingValue <= 0
      },
      recommendedUpsells() {
        let cart = store.state.shopify_cart
        let upsells = []
        if (!cart) {
          return []
        }
        let cartItems = cart
        devLog(`shopify_cart`, cartItems)
        cartItems.forEach((item) => {
          if (item && item.upsell_products) {
            item.upsell_products.forEach((upsell) => {
              upsell.variants = upsell.variants.map((e) => {
                e.price = e.price / 100

                return e
              })

              let isAlreadyInUpsells = upsells.find((e) => e.id == upsell.id)

              if (!isAlreadyInUpsells) {
                upsells.push(upsell)
              }
            });
          }
        });

        devLog("upsells", upsells);
        return upsells;
      },
      loadingCart() {
        return store.state.loadingCart
      },
      cartTotal() {
        if (this.cartData.length > 0) {
          return this.cartData[0].total_price
        }
      },
      original_total_price() {
        if (this.cartData.length > 0) {
          return this.cartData[0].original_total_price
        }
      },
      cartCount() {
        if (this.cartData.length > 0) {
          return this.cartData[0].item_count
        }
      },
      isFreeShipping() {
        if (this.cartData.length > 0) {
          return (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          )
        }
      },
      remaingShippingPercetange() {
        if (this.cartData.length > 0) {
          let percentage =
            (this.cartData[0].total_price /
              freeShippingSettings.freeShippingThreshold) *
            100
          if (percentage > 100) {
            percentage = 100
          }
          return percentage
        }
      },

      awayFromFreeShipping() {
        if (this.cartData.length > 0) {
          return (
            freeShippingSettings.freeShippingThreshold -
            this.cartData[0].total_price
          )
        }
      },
      freeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        if (cart_total && cart_total >= 200) {
          return "".toUpperCase()
        }

        if (this.cartData.length > 0) {
          return freeShippingSettings.freeShippingMessage.replace(
            "_value_",
            this.money(freeShippingSettings.freeShippingThreshold)
          )
        }
      },
      showTopLine() {
        return this.cartTotal / 100 < 250
        return true
      },
      gotFreeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        // if(cart_total && cart_total >= 250){
        // return `🎉 You’ve earned free shipping!`
        // }
        if (this.cartData.length > 0) {
          if (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          ) {
            return freeShippingSettings.successMessage
          } else {
            return ""
          }
        }
      },
      awayFreeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        // let thrithyPercetnageOffAway = 250 - cart_total;
        // if(cart_total && cart_total >= 200 && cart_total<250){
        //   return freeShippingSettings.remainingMessage.replace(
        //     "_value_",
        //     this.money(thrithyPercetnageOffAway*100)
        //   );

        // }

        if (this.cartData.length > 0) {
          if (
            this.cartData[0].total_price <
            freeShippingSettings.freeShippingThreshold
          ) {
            return freeShippingSettings.remainingMessage.replace(
              "_value_",
              this.money(this.awayFromFreeShipping)
            )
          } else {
            return ""
          }
        }
      },

      isvisibleCart() {
        return !slideCartState.hidden
      },
      menuDrawer() {
        return menuState.hidden
      },
      cart() {
        return this.cartData[0]
      },
      reverseCart() {
        let items = this.cartData[0]?.items
        if (items && items.length > 0) {
          items = items.filter((e) => {
            return e.sku != "TIER6"
          })
          items = items.map((e, i) => {
            e.line = i

            return e
          })
        }

        return items?.reverse()
      },
      recommendedCollectionNew() {
        if (this.recommendedUpsells && this.recommendedUpsells.length > 0) {
          return this.recommendedUpsells
        } else {
          return store.state.recommendedCollection
        }
      },
      freeGiftsCollection() {
        return store.state.freeGiftsCollection
      },
      recommendedCollection() {
        return store.state.recommendedCollection
      },

      disableCart() {
        return store.state.updatingCart
      },
    },
    mounted() {
      let scrollEvent = this.scrollUpdate
      document.addEventListener("scroll", function (e) {
        scrollEvent(e)
      })

      // Reset the checkout button when the user returns to the cart (e.g. back from Shopify checkout).
      // Covers bfcache restore (`pageshow` persisted=true), fresh reload, and tab-return (visibilitychange).
      const resetCheckoutButton = () => {
        this.checkoutLoading = false
        this.$nextTick(() => {
          const btnEl =
            (this.$refs && this.$refs.checkoutBtnText) ||
            document.querySelector(".checkout-btn-wrapper button span:last-of-type")
          if (btnEl) btnEl.innerHTML = "CHECKOUT"
        })
      }
      window.addEventListener("pageshow", resetCheckoutButton)
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") resetCheckoutButton()
      })
      resetCheckoutButton()
    },
    components: {
      "single-upsell": SingleUpsell,
      "single-upsell-new": SingleUpsellNew,
      carousel: VueCarousel.Carousel,
      slide: VueCarousel.Slide,
      pagination: VueCarousel.Pagination,
      navigation: VueCarousel.Navigation,
    },
    created() {
      store.getCart()
      store.getRecommendedCollection()
      store.getFreeGiftsCollection()
      let view = getParam("view")
      if (view && view == "redirect_to_stripe_checkout") {
        // let discountCode = getParam("hcp_code");
        let provider_code = getParam("hcp_code")
        this.provider_code = provider_code
        this.gotoCheckout()
      }

      // Initialize emitter if it doesn't exist
      if (!window.emitter) {
        window.emitter = {
          events: {},
          on(event, callback) {
            if (!this.events[event]) {
              this.events[event] = []
            }
            this.events[event].push(callback)
          },
          emit(event, data) {
            if (this.events[event]) {
              this.events[event].forEach((callback) => callback(data))
            }
          },
        }
      }

      window.emitter.on("new_provider_code", (e) => {
        if (e.code && e.code != "" && e.code != this.provider_code) {
          this.provider_code = e.code
        }
      })
    },
    watch: {
      isvisibleCart: function (val) {
        let providerCode = localStorage.getItem("provider_code")
        if (!this.provider_code) {
          if (providerCode && providerCode != "null") {
            this.provider_code = providerCode
          }
        }

        if (!providerCode) {
          let discountCode = localStorage.getItem("discount_code")
          if (discountCode && discountCode != "null") {
            this.discountCode = discountCode
          }
        }
      },
      original_total_price: function (val) {
        // original_total_price
        //offer-bar
        if (val) {
          try {
            document
              .querySelector("offer-bar")
              .setAttribute("subtotal", val / 100)
          } catch (ex) {}
        }
      },
    },
  }).mount("#cart-with-header")
}

$(document).on("ajaxProduct:added", function () {
  toggleCart.showCart()
})

$(document).on("click", ".js-drawer-open-cart", function (e) {
  if (window.CART_TYPE == "DRAWER") {
    e.preventDefault()
    toggleCart.showCart()
  }
})

